import i18n from '@/plugins/i18n';

export const charts = [
  {
    width: '100%',
    isUsages: true,
    title: i18n.global.t('active-sessions'),
    header: {
      title: i18n.global.t('active-sessions'),
      titleIcon: '',
      content: [],
      HideCenterMiscContent: true,
      displayOnlyUnit: false,
      displayCustomButton: false,
      customButtonProp: {
        title: '',
      },
    },
    chartColor: ['#98ED78'],
    height: '12.5em',
    entityType: 'Mobile',
    independentSelector: false,
    sortOrder: 'DES',
    metricType: 'REGULAR_VALUE',
    metricName: 'mobile',
    queryMetricType: 'readMobileCustomMetricsValues',
    customMetricName: 'activeUsersByOs',
    childQueries: [],
    chartType: 'ApexChartLine',
    unit: i18n.global.t('cpmWithFullForm'),
    axisLabels: {
      x: i18n.global.t('aws.time'),
      y: i18n.global.t('number-of-sessions'),
    },
    labels: {
      xAxis: i18n.global.t('aws.time'),
      yAxis: 'CPM',
    },
  },
];
